import PropTypes from 'prop-types';

import './ListingLabel.scss';

const ListingLabel = ({
  icon = null,
  title = null,
  children = null,
  info = null
}) => (
  <li className="listing-label-item" aria-label={title}>
    {icon && <span className="listing-label-item__icon">{icon}</span>}
    <div className="listing-label-item__content">
      {title && <div className="listing-label-item__title">{title}</div>}
      {info && <div className="listing-label-item__description">{info}</div>}
      {children && (
        <div className="listing-label-item__description">{children}</div>
      )}
    </div>
  </li>
);

ListingLabel.propTypes = {
  icon: PropTypes.node,
  title: PropTypes.node,
  info: PropTypes.node,
  children: PropTypes.node
};

export default ListingLabel;
